<script setup lang="ts">
import { fr } from '@nuxt/ui/locale'

/**
 * Suffixe commun des titres d'onglet.
 *
 * Chaque page ne déclare que son contexte (« Pages - Ma page », « Médiathèque »)
 * et le nom de l'application est ajouté ici, en un seul endroit. Le gabarit vit
 * dans `app.vue` et non dans `nuxt.config` : une fonction n'y serait pas
 * sérialisable, et le suffixe ne s'appliquerait pas.
 */
useHead({
  titleTemplate: chunk => chunk ? `${chunk} - Admin Site - ACC Sud Ouest` : 'Admin Site - ACC Sud Ouest',
})

const authStore = useAuthStore()
</script>

<template>
  <UApp :toaster="{ position: 'top-right' }" :locale="fr">
    <!--
      Avertissement de session révoquée, hors du layout : il doit rester visible
      quel que soit l'écran, y compris sur une page qui n'en utilise aucun.
    -->
    <SessionRevokedNotice />

    <!--
      Palette de commandes, hors du layout pour la même raison : le raccourci
      doit répondre depuis n'importe quel écran, y compris ceux qui n'utilisent
      aucun layout. Sans session, elle n'aurait que des destinations
      inaccessibles — d'où la garde.
    -->
    <AdminCommandPalette v-if="authStore.authenticated" />

    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </UApp>
</template>
